<template>
    <div class="sidebar">
        <div>
            <slot name="top"></slot>
        </div>
        <div class="sideFilter">
            <slot name="filter">
                <span class="filter-text">过滤器</span>
                <span class="filter-btn">
                <i class="el-icon-s-tools" @click="ConfigurationFilter"></i>
                      <el-dialog title="配置过滤器" :visible.sync="dialogFormVisible2" custom-class="sidebarDialog" style="text-align: left;" :close-on-click-modal="false">

                        <div class="sideFilterContain">
                            <div class="sideFilterNotShow">
                                <div style="font-weight: 600;font-size: 14px">未显示</div>
                                <div class="notShowCon" >
                                    <el-scrollbar>
                                        <div style="width: 100%;height: 400px" id="workOrderNotShowFilter">
                                            <div class="notShowAddTime"
                                                 v-for="(item,index) in allOrderFilterList"
                                                 :key="index+1"
                                                 @click="filterToRight(item.id)"
                                                 @mouseenter="changeFilter"
                                            >
                                                <div v-if="item.display===false">{{item.name}}</div>
                                            </div>
                                        </div>
                                    </el-scrollbar>

                                </div>
                            </div>
                            <div class="sideFilterShow">
                                <div style="font-weight: 600;font-size: 14px">已显示</div>
                                <div class="showCon">
                                    <el-scrollbar style="height: 100%">
                                        <div style="width: 100%;height: 400px">
                                            <div id="workOrderFilter">
                                                   <div class="allWorkOrderList"
                                                        v-for="(item,index) in allOrderFilterList"
                                                        :key="index+1"
                                                        @click="filterToLeft(item.id)"
                                                   >
                                                    <div class="allWorkOrderListName" v-if="item.display===true">
                                                        {{item.name}}
                                                    </div>
                                                    <div style="cursor: move" @mouseenter="resortFilter" class="handle" v-if="item.display===true">
                                                        <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px" >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-scrollbar>

                                </div>
                            </div>
                        </div>

                        <div slot="footer" class="dialog-footer">
                             <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                             <el-button type="primary" @click="workOrderFilterDisplay">确 定</el-button>
                         </div>
                    </el-dialog>
            </span>
            </slot>
        </div>
        <slot name="sideFilter-contain">
            <div class="sideFilter-contain">
                <el-scrollbar style="height:100%;overflow: hidden">
                    <div class="scrollbarContain">
                        <slot name="scrollbar">
                            <div
                                    v-for="(item,index) in orderFilterList"
                                    class="sidefilter-title"
                                    :class="{sidebaractive:currentIndex===item.id}"
                                    @mouseover="mouseClick(index)"
                                    @mouseout="mouseOutClick"
                                    :key="item.id"

                            >
                                <span class="sideFilterText" @click="filterClick(index,item.id)">{{item.name}}</span>
                                <span>
                                       <span class="sideFilterNum" v-if="moseover!==index&&item._count >999&&item.isDefault!==true">999+</span>
                                        <span class="sideFilterNum" v-else-if="moseover!==index&&item._count <999&&item.isDefault!==true">{{item._count}}</span>
                                        <span class="sideFilterNum" v-if="item._count >999&&item.isDefault===true">999+</span>
                                        <span class="sideFilterNum" v-else-if="item._count <999&&item.isDefault===true">{{item._count}}</span>
                                        <span class="sideFilterNum" v-show="moseover===index&&item.isDefault!==true">
                                             <img src="./../../../assets/images/fieldmanage/rivese.png" @click="itemClick(index,item.id)" style="width: 16px;height: 16px"/>
                                        </span>
                                </span>
                            </div>

                        </slot>
                        <div class="customize-filter">
                            <slot name="defaultfilter">
                                <el-button type="text" @click="customFilter">
                                    <i class="el-icon-circle-plus-outline"></i>
                                    <span class="siderFilter">自定义过滤器</span>
                                </el-button>
                                <el-dialog title="自定义过滤器" :visible.sync="dialogFormVisible" custom-class="sidebarDialog" style="text-align: left;"  :close-on-click-modal="false">

                                        <div class="filterName">
                                            <el-row :gutter="20">
                                                <el-col :span="4" style="padding-right: 0px">
                                                    <div class="text"><span class="biaoji">*</span>过滤器名称</div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <el-input v-model="filterName" autocomplete="off" maxlength="15" placeholder="请输入过滤器名称" style="width: 100%"></el-input>
                                                </el-col>
                                            </el-row>
                                        </div>
                                        <div class="visibleRange">
                                            <el-row :gutter="20">
                                                <el-col :span="4">
                                                    <div class="textRange">
                                                        可见范围
                                                    </div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <div>
                                                        <el-radio v-model="rangeRadio" label="1">仅自己可见</el-radio>
                                                        <el-radio v-model="rangeRadio" label="2">全员可见</el-radio>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <div class="workOrderTemplateSelect">
                                    <el-row :gutter="20">
                                      <el-col :span="4">
                                        <div class="templateName">
                                          工单模板
                                        </div>
                                      </el-col>
                                      <el-col :span="20">
                                        <div class="templateSelect">
                                          <el-select v-model="templateSelect"
                                                     placeholder="请选择"
                                                     multiple
                                                     style="width: 100%;"
                                          >
                                            <div>
                                               <el-option
                                                   v-for="item in workOrderTemplate.list"
                                                   :key="item.id"
                                                   :label="item.name"
                                                   :value="item.id">
                                               </el-option>
                                            </div>

                                          </el-select>
                                        </div>
                                      </el-col>
                                    </el-row>
                                  </div>
                                        <div class="state" v-if="status.list.length > 0">
                                            <el-row :gutter="20">
                                                <el-col :span="4">
                                                    <div class="textState">状态</div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <div >
                                                        <el-checkbox-group v-model="statusList">
                                                            <el-checkbox
                                                                    v-for="item in status.list"
                                                                    :key="item.id"
                                                                    :label="item.id"
                                                                    :value="item.name"
                                                                    style="min-width:72px;padding-right: 10px"
                                                            >{{item.name}}</el-checkbox>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <div class="priority">
                                            <el-row :gutter="20">
                                                <el-col :span="4">
                                                    <div class="textPriority">优先级</div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <div>
                                                        <el-checkbox-group v-model="priorityList">
                                                            <el-checkbox
                                                                    v-for="(item,index) in prioritySelect"
                                                                    :key="index"
                                                                    :label="item.label"
                                                                    style="min-width: 72px;padding-right: 10px"
                                                            >
                                                                {{item.value}}
                                                            </el-checkbox>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>


                                        <div class="acceptance" style="clear: both">
                                            <el-row :gutter="20">
                                                <el-col :span="12">
                                                    <div class="groups">
                                                        <el-row :gutter="20">
                                                            <el-col :span="8" >
                                                                <div class="acceptanceGroup" >受理组</div>
                                                            </el-col>
                                                            <el-col :span="16">
                                                                <el-select
                                                                        v-model="acceptanceGroup"
                                                                        placeholder="请选择"
                                                                        multiple
                                                                        style="height: 80%;position: relative"
                                                                >
                                                                    <div >
                                                                        <el-input
                                                                                v-model="groupInput"
                                                                                autocomplete="off"
                                                                                style="width: 100%;position: absolute;top: 0;z-index: 9;"
                                                                                placeholder="可搜索"
                                                                                class="kesousuo"
                                                                                @input="changeSelectGroup"
                                                                        >
                                                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                                                        </el-input>
                                                                    </div>
                                                                    <div >
                                                                         <el-option value="" label="无" style="margin-top: 36px"></el-option>
                                                                    </div>
                                                                    <div>
                                                                        <el-option
                                                                                v-for="item in selectAccountGroup"
                                                                                :key="item.id"
                                                                                :label="item.name"
                                                                                :value="item.id">
                                                                        </el-option>
                                                                    </div>

                                                                </el-select>
                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div class="person">
                                                        <el-row :gutter="20">
                                                            <el-col :span="8">
                                                                <div class="acceptancePerson">受理人</div>
                                                            </el-col>
                                                            <el-col :span="16">
                                                                <el-select v-model="acceptancePerson" placeholder="请选择" multiple style="position: relative">
                                                                    <div>
                                                                        <el-input
                                                                                v-model="personInput"
                                                                                autocomplete="off"
                                                                                style="width: 100%;position: absolute;top: 0;z-index: 9"
                                                                                placeholder="可搜索"
                                                                                class="kesousuo"
                                                                                @input="changeSelectPerson"
                                                                        >
                                                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                                                        </el-input>
                                                                    </div>
                                                                    <div >
                                                                        <el-option value="" label="无" style="margin-top: 36px"></el-option>
                                                                    </div>
                                                                    <div>
                                                                        <el-option
                                                                                v-for="item in selectAccountPerson"
                                                                                :key="item.id"
                                                                                :label="item.name"
                                                                                :value="item.id">
                                                                        </el-option>
                                                                    </div>

                                                                </el-select>
                                                            </el-col>
                                                        </el-row>

                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <div class="create" style="clear: both">
                                            <el-row :gutter="20">
                                                <el-col :span="12">
                                                    <div class="person" style="clear: both">
                                                        <el-row :gutter="20">
                                                            <el-col :span="8">
                                                                <div class="createPerson" >创建人</div>
                                                            </el-col>
                                                            <el-col :span="16">
                                                                <div>
                                                                    <el-select v-model="createPerson"  placeholder="请选择" multiple style="position: relative">
                                                                        <div>
                                                                            <el-input
                                                                                    v-model="createPersonInput"
                                                                                    autocomplete="off" style="width: 100%;position: absolute;top: 0;z-index: 9"
                                                                                    placeholder="可搜索"
                                                                                    class="kesousuo"
                                                                                    @input="changeSelectCreatePerson"
                                                                            >
                                                                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                                                            </el-input>
                                                                        </div>
                                                                        <div v-if="selectPrincipal.length===0">
                                                                            <el-option value="" style="height: 5px"></el-option>
                                                                        </div>
                                                                        <div style="margin-top: 36px;">
                                                                            <el-option
                                                                                    v-for="item in selectPrincipal"
                                                                                    :key="item.id"
                                                                                    :label="item.name"
                                                                                    :value="item.id">
                                                                            </el-option>
                                                                        </div>

                                                                    </el-select>
                                                                </div>
                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-row :gutter="20">
                                                        <el-col :span="8">
                                                            <div class="focusPerson" style="clear: both" >关注人</div>
                                                        </el-col>
                                                        <el-col :span="16">
                                                            <div class="focus">
                                                                    <el-select
                                                                            v-model="focusPerson"
                                                                            placeholder="请选择"
                                                                            multiple
                                                                            style="position: relative;"
                                                                    >
                                                                        <div>
                                                                            <el-input
                                                                                    v-model="focusPersonInput"
                                                                                    autocomplete="off"
                                                                                    style="width: 100%;position: absolute;top: 0;z-index: 9"
                                                                                    placeholder="可搜索"
                                                                                    class="kesousuo"
                                                                                    @input="changeSelectCreatePerson2"
                                                                            >
                                                                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                                                            </el-input>

                                                                        </div>
                                                                        <div >
                                                                            <el-option value="" label="无" style="margin-top: 36px"></el-option>
                                                                        </div>
                                                                        <div>
                                                                            <el-option
                                                                                    v-for="item in selectFocusPerson"
                                                                                    :key="item.id"
                                                                                    :label="item.name"
                                                                                    :value="item.id">
                                                                            </el-option>
                                                                        </div>

                                                                    </el-select>
                                                            </div>
                                                        </el-col>
                                                    </el-row>

                                                </el-col>
                                            </el-row>


                                        </div>
                                    <div class="createDateRange" style="clear: both">
                                        <el-row :gutter="20">
                                            <el-col :span="4">
                                                <div class="textRange">
                                                    创建时间
                                                </div>
                                            </el-col>
                                            <el-col :span="20">
                                                <div>
                                                    <el-date-picker
                                                            style="width: 100%"
                                                            v-model="createDateRange"
                                                            type="datetimerange"
                                                            range-separator="至"
                                                            start-placeholder="开始日期"
                                                            end-placeholder="结束日期"
                                                            :default-time="['00:00:00', '23:59:59']"
                                                    >
                                                    </el-date-picker>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <div class="updateTimeRange" style="clear: both">
                                        <el-row :gutter="20">
                                            <el-col :span="4">
                                                <div class="textRange">
                                                    更新时间
                                                </div>
                                            </el-col>
                                            <el-col :span="20">
                                                <div>
                                                    <el-date-picker
                                                            style="width: 100%"
                                                            v-model="updateTimeRange"
                                                            type="datetimerange"
                                                            range-separator="至"
                                                            start-placeholder="开始日期"
                                                            end-placeholder="结束日期"
                                                            :default-time="['00:00:00', '23:59:59']"
                                                    >
                                                    </el-date-picker>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>

                                        <div v-for="(item,index) in fieldSelectList" :key="item.id">
                                            <div class="select" v-if="item.name!==''" style="margin-right: -20px">
                                                <div class="customFieldsLong"  style="height: auto;margin-bottom: 14px;float: left;width:calc(49% - 15px);display: flex;margin-right: 20px">
                                                    <div class="fieldLong" style="line-height: 1.5;margin-top: 8px;width:94px;margin-right: 10px">{{item.name}}</div>
                                                    <div style="width: 190px">
                                                        <el-select v-model="selectValue[index]"
                                                                   placeholder="请选择"
                                                                   multiple
                                                        >
                                                            <div>
                                                                <el-option
                                                                        v-for="items in item.extInfo.exinfo"
                                                                        :key="items.value"
                                                                        :label="items.value"
                                                                        :value="items.value">
                                                                </el-option>
                                                            </div>

                                                        </el-select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div v-for="(item,index) in fieldCascadeList" :key="item.id">
                                            <div class="cascadeList"  style="margin-right: -20px">
                                                <div style="height: auto;margin-bottom: 14px;float: left;width:calc(49% - 15px);display: flex;margin-right: 20px">
                                                    <div class="fieldLong" style="line-height: 1.5;margin-top: 8px;width:94px;margin-right: 10px">{{item.name}}
                                                    </div>
                                                    <div style="width: 192px">
                                                        <el-cascader
                                                                v-model="cascadeValue[index]"
                                                                :props="props"
                                                                :options="item.extInfo.cascadeDown[0].options"
                                                        ></el-cascader>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>

                                        <div v-for="(item,index) in fieldCheckBoxList" :key="item.id">
                                        <div class="radioCheckbox" v-if="item.name!==''" style="clear: both">
                                            <el-row :gutter="20">
                                                <el-col :span="4">
                                                    <div class="fieldLong" style="line-height: 1.5;margin-top: 6px">{{item.name}}
                                                    </div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <div class="checkboxGroup" >
                                                        <el-checkbox-group v-model="checkBoxCheck[index]">
                                                            <el-checkbox
                                                                    v-for="(items,index) in item.extInfo.exinfo"
                                                                    :label="items.value"
                                                                    :key="index"
                                                                    :value="items.value"
                                                                    style="min-width:72px;padding-right: 10px"
                                                            ></el-checkbox>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>

                                       <div v-for="(item,index) in fieldRadioList" :key="item.id">
                                        <div class="radioCheckbox2" v-if="item.name!==''" style="clear: both">
                                            <el-row :gutter="20">
                                                <el-col :span="4">
                                                    <div class="fieldLong" style="line-height: 1.5;margin-top: 6px">{{item.name}}
                                                    </div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <div class="checkboxGroup2">
                                                        <el-checkbox-group v-model="radioCheck[index]">
                                                            <el-checkbox
                                                                    v-for="(items,index) in item.extInfo.exinfo"
                                                                    :label="items.value"
                                                                    :value="items.value"
                                                                    :key="index"
                                                                    style="min-width:72px;padding-right: 10px"
                                                            ></el-checkbox>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                       <div v-for="(item,index) in datePickerList" :key="item.id">
                                        <div class="sideDefaultDate" v-if="item.name!==''" style="clear: both">
                                            <div class="defaultDateFiled">
                                                <el-row :gutter="20">
                                                    <el-col :span="4">
                                                        <div class="fieldLong" style="line-height: 1.5;margin-top: 8px">{{item.name}}</div>
                                                    </el-col>
                                                    <el-col :span="20">
                                                        <div class="defautBlock">
                                                            <el-date-picker
                                                                    v-model="datePicker[index]"
                                                                    type="daterange"
                                                                    range-separator="至"
                                                                    start-placeholder="开始日期"
                                                                    end-placeholder="结束日期"
                                                                    style="width:100%"
                                                            >
                                                            </el-date-picker>
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                    </div>

                                       <div v-for="(item,index) in timePickerList" :key="item.id">
                                        <div class="sideDefaultTime" v-if="item.name!==''" style="clear: both">
                                            <el-row :gutter="20">
                                                <el-col :span="4">
                                                    <div class="fieldLong" style="line-height: 1.5;margin-top: 8px">{{item.name}}</div>
                                                </el-col>
                                                <el-col :span="20">
                                                    <div>
                                                        <el-time-picker
                                                                is-range
                                                                v-model="timePicker[index]"
                                                                range-separator="至"
                                                                start-placeholder="开始时间"
                                                                end-placeholder="结束时间"
                                                                placeholder="选择时间范围"
                                                                style="width: 100%;"
                                                        >
                                                        </el-time-picker>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                       <div slot="footer" class="dialog-footer" style="clear:both;">
                                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                                        <el-button type="primary" @click="addWorkOrderFilter">确 定</el-button>
                                    </div>
                                </el-dialog>

                            </slot>

                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </slot>

        <el-dialog title="编辑过滤器" :visible.sync="dialogFormVisible1" custom-class="sidebarDialog" style="text-align: left;"  :close-on-click-modal="false">

            <div class="filterName">
                <el-row :gutter="20">
                    <el-col :span="4" style="padding-right: 0px">
                        <div class="text"><span class="biaoji">*</span>过滤器名称</div>
                    </el-col>
                    <el-col :span="20">
                        <el-input v-model="filterName" autocomplete="off" placeholder="请输入过滤器名称" maxlength="15" style="width: 100%"></el-input>
                    </el-col>
                </el-row>
            </div>
            <div class="visibleRange">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="textRange">
                            可见范围
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div>
                            <el-radio v-model="rangeRadio" label="1">仅自己可见</el-radio>
                            <el-radio v-model="rangeRadio" label="2">全员可见</el-radio>
                        </div>
                    </el-col>
                </el-row>
            </div>

          <div class="workOrderTemplateSelect">
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="templateNmae">
                  工单模板
                </div>
              </el-col>
              <el-col :span="20">
                <div class="templateSelect">
                  <el-select v-model="templateSelect"
                             placeholder="请选择"
                             multiple
                             style="width: 100%;"
                  >
                    <div>
                      <el-option
                          v-for="item in workOrderTemplate.list"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </div>

                  </el-select>
                </div>
              </el-col>
            </el-row>
          </div>


            <div class="state">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="textState">状态</div>
                    </el-col>
                    <el-col :span="20">
                        <div>
                            <el-checkbox-group v-model="statusList">
                                <el-checkbox
                                        v-for="item in newStatus.list"
                                        :key="item.id"
                                        :label="item.id"
                                        style="min-width:72px;padding-right: 10px"

                                >{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="priority">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="textPriority">优先级</div>
                    </el-col>
                    <el-col :span="20">
                        <div>
                            <el-checkbox-group v-model="priorityList" style="height: 40px">
                                <el-checkbox
                                        v-for="(item,index) in prioritySelect"
                                        :key="index"
                                        :label="item.label"
                                        style="min-width:72px;padding-right: 10px"
                                >
                                    {{item.value}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-col>
                </el-row>
            </div>


            <div class="acceptance">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="groups">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <div class="acceptanceGroup" >受理组</div>
                                </el-col>
                                <el-col :span="16">
                                    <el-select
                                            v-model="acceptanceGroup"
                                            placeholder="请选择"
                                            multiple
                                            style="height: 80%;position: relative"
                                    >
                                        <div>
                                            <el-input
                                                    v-model="editGroupInput"
                                                    autocomplete="off"
                                                    style="width: 100%;position:absolute;top: 0;left: 0;z-index: 9"
                                                    placeholder="可搜索"
                                                    class="kesousuo"
                                                    @input="changeSelectGroup"
                                            ></el-input>
                                        </div>
                                        <div >
                                            <el-option value="" label="无" style="margin-top: 36px"></el-option>
                                        </div>
                                        <div>
                                            <el-option
                                                    v-for="item in selectAccountGroup"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </div>

                                    </el-select>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="person">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <div class="acceptancePerson">受理人</div>
                                </el-col>
                                <el-col :span="16">
                                    <el-select
                                        v-model="acceptancePerson"
                                        placeholder="请选择"
                                        multiple
                                        style="position: relative"
                                    >
                                        <div>
                                            <el-input
                                                    v-model="personInput"
                                                    autocomplete="off"
                                                    style="width: 100%;position: absolute;top: 0;left: 0;z-index: 9"
                                                    placeholder="可搜索"
                                                    class="kesousuo"
                                                    @input="changeSelectPerson"

                                            ></el-input>
                                        </div>
                                        <div >
                                            <el-option value="" label="无" style="margin-top: 36px"></el-option>
                                        </div>
                                        <div>
                                            <el-option
                                                    v-for="item in selectAccountPerson"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </div>

                                    </el-select>
                                </el-col>
                            </el-row>

                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="create" style="clear:both;">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="person">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <div class="createPerson" >创建人</div>
                                </el-col>
                                <el-col :span="16">
                                    <div>
                                        <el-select v-model="createPerson" placeholder="请选择" multiple style="position: relative">
                                            <div>
                                                <el-input
                                                        v-model="createPersonInput"
                                                        autocomplete="off"
                                                        style="width: 100%;position: absolute;top: 0;left: 0;z-index: 9"
                                                        placeholder="可搜索"
                                                        class="kesousuo"
                                                        @input="selectEditFilterPerson"
                                                ></el-input>
                                            </div>
                                            <div v-if="editSelectPrincipal.length===0">
                                                <el-option value="" style="height: 5px"></el-option>
                                            </div>
                                            <div style="margin-top: 36px;">
                                                <el-option
                                                        v-for="item in editSelectPrincipal"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </div>

                                        </el-select>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="focusPerson" >关注人</div>
                            </el-col>
                            <el-col :span="16">
                                <div class="focus">

                                    <div>
                                        <el-select v-model="focusPerson" placeholder="请选择" multiple style="position: relative">
                                            <div>
                                                <el-input
                                                        v-model="focusPersonInput"
                                                        autocomplete="off"
                                                        style="width: 100%;position: absolute;top: 0;left: 0;z-index: 9"
                                                        placeholder="可搜索"
                                                        class="kesousuo"
                                                        @input="selectEditFilterFocusPerson"
                                                ></el-input>
                                            </div>
                                            <div >
                                                <el-option value="" label="无" style="margin-top: 36px"></el-option>
                                            </div>
                                            <div>
                                                <el-option
                                                        v-for="item in editSelectFocusPerson"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </div>

                                        </el-select>
                                    </div>

                                </div>
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>


            </div>
            <div class="createDateRange" style="clear: both">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="textRange">
                            创建时间
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div>
                            <el-date-picker
                                    style="width: 100%"
                                    v-model="createDateRange"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :default-time="['00:00:00', '23:59:59']"
                            >
                            </el-date-picker>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="updateTimeRange" style="clear: both">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="textRange">
                            更新时间
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div>
                            <el-date-picker
                                    style="width: 100%"
                                    v-model="updateTimeRange"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :default-time="['00:00:00', '23:59:59']"
                            >
                            </el-date-picker>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div v-for="(item,index) in fieldSelectList" :key="item.id">
                <div class="select" v-if="item.name!==''" style="margin-right: -20px">

                        <div class="customFieldsLong" style="height: auto;margin-bottom: 14px;float: left;width:calc(49% - 15px);display: flex;margin-right: 20px">

                                <div class="fieldLong" style="line-height: 1.5;margin-top: 8px;width:94px;margin-right: 10px">{{item.name}}</div>


                                <div style="width: 190px">
                                    <el-select v-model="selectValue[index]"
                                               placeholder="请选择"
                                               multiple
                                               style="width: 100%;"
                                    >
                                        <div>
                                            <el-option
                                                    v-for="items in item.extInfo.exinfo"
                                                    :key="items.value"
                                                    :label="items.value"
                                                    :value="items.value">
                                            </el-option>
                                        </div>

                                    </el-select>
                                </div>

                        </div>

                </div>
            </div>
            <div v-for="(item,index) in fieldCascadeList" :key="item.id">
                <div class="cascadeList" style="margin-right: -20px">

                       <div style="height: auto;margin-bottom: 14px;float: left;width:calc(49% - 15px);display: flex;margin-right: 20px">
                           <div class="fieldLong" style="line-height: 1.5;margin-top: 8px;width:94px;margin-right: 10px">{{item.name}}
                           </div>


                           <div style="width: 190px">
                               <el-cascader
                                       :props="props"
                                       v-model="cascadeValue[index]"
                                       :options="item.extInfo.cascadeDown[0].options"
                               ></el-cascader>
                           </div>
                       </div>
                </div>

            </div>

            <div v-for="(item,index) in fieldCheckBoxList" :key="item.id" >
                <div class="radioCheckbox" v-if="item.name!==''" style="clear:both;">
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <div class="fieldLong" style="line-height: 1.5;">{{item.name}}
                            </div>
                        </el-col>
                        <el-col :span="20">
                            <div class="checkboxGroup" >
                                <el-checkbox-group v-model="checkBoxCheck[index]">
                                    <el-checkbox
                                            v-for="(items,index) in item.extInfo.exinfo"
                                            :label="items.value"
                                            :key="index"
                                            style="min-width:72px;padding-right: 10px"

                                    >{{items.value}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div v-for="(item,index) in fieldRadioList" :key="item.id" >
                <div class="radioCheckbox2" v-if="item.name!==''" style="clear:both;">
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <div class="fieldLong" style="line-height: 1.5">{{item.name}}
                            </div>
                        </el-col>
                        <el-col :span="20">
                            <div class="checkboxGroup2">
                                <el-checkbox-group v-model="radioCheck[index]">
                                    <el-checkbox
                                            v-for="(items,index) in item.extInfo.exinfo"
                                            :label="items.value"
                                            :key="index"
                                            style="min-width:72px;padding-right: 10px"
                                    >{{items.value}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div v-for="(item,index) in datePickerList" :key="item.id" >
                <div class="sideDefaultDate" v-if="item.name!==''" style="clear:both;">
                    <div class="defaultDateFiled">
                        <el-row :gutter="20">
                            <el-col :span="4">
                                <div class="fieldLong" style="line-height: 1.5">{{item.name}}</div>
                            </el-col>
                            <el-col :span="20">
                                <div class="defautBlock">
                                    <el-date-picker
                                            v-model="datePicker[index]"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            style="width:100%"
                                    >
                                    </el-date-picker>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <div v-for="(item,index) in timePickerList" :key="item.id" >
                <div class="sideDefaultTime" v-if="item.name!==''" style="clear:both;">
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <div class="fieldLong" style="line-height: 1.5">{{item.name}}</div>
                        </el-col>
                        <el-col :span="20">
                            <div>
                                <el-time-picker
                                        is-range
                                        v-model="timePicker[index]"
                                        range-separator="至"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        placeholder="选择时间范围"
                                        style="width: 100%;"
                                >
                                </el-time-picker>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>


            <div slot="footer" class="dialog-footer" style="clear: both">
                <el-button @click="IsDeleteOrdeFilter" type="danger" style="float: left">删除</el-button>
                <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="ModifyWorkOrderFilter">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
                title="删除过滤器"
                :visible.sync="dialogVisible"
                width="30%"
               >
            <span>是否删除该过滤器</span>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleteOrderFilter">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import Sortable from 'sortablejs'
    export default {
        name: "SideBar",
        data(){
            return{
              num:1250,
              num2:500,
                filterName:'',
              message:[
                  {id:1,text:'我的未解决的工单',num:1200},
                  {id:2,text:'我的已解决的工单',num:800},
                  {id:3,text:'组内未解决的工单',num:900},
                  {id:4,text:'所有未解决的工单',num:1250},
              ],
                dialogTableVisible: false,
                dialogFormVisible: false,
                dialogFormVisible1:false,
                dialogFormVisible2:false,
                dialogVisible:false,
                rangeRadio:'1',
                statusList:[],
                priorityList:[],
                prioritySelect:[
                    {
                        value:'紧急',
                        label:'URGENT'
                    },
                    {
                        value:'高',
                        label:'HIGH'
                    },
                    {
                        value:'中',
                        label:'MIDDLE'
                    },
                    {
                        value: '低',
                        label:'LOW'
                    }
                ],
                acceptanceGroup:[],
                datePicker:[],
                timePicker:[],
                checkBoxCheck: [],
                radioCheck:[],
                acceptancePerson:[],
                createPerson:[],
                focusPerson:[],
                field:'',
                selectValue:[],
                isActive:0,
                groupInput:'',
                editGroupInput:'',
                personInput:'',
                createPersonInput:'',
                focusPersonInput:'',
                moseover:'',
                mouseout:0,
                notshowList:['待显示过滤器1','待显示过滤器2','待显示过滤器3'],
                showList:['我的未解决工单','我的已解决工单','组内未解决工单','组内已解决工单','全部未解决工单','我的关注工单','我创建的工单','我的名字很长很长很长很长很长'],
                fileMiddleData: {},
                fileMiddleIndex:'',
                middleData:{},
                middleIndex:'',
                currentIndex:'',
                id:'',
                sideFilter:['我的未解决工单','我的已解决工单','组内未解决工单','组内已解决工单','全部未解决工单','我的关注工单','我创建的工单','我的名字很长很长很长很长很长'],
                fields:{
                  list:[]
                },
                pageSize:20,
                currentPage:1,
                status:{
                  list:[]
                },
                newStatus:{
                  list:[]
                },
                accountGroup:{
                  list:[]
                },
                accountPerson:{
                  list:[]
                },
                Principals:{
                  list:[]
                },
                dateName:'',
                timeName:'',
                newFields:{
                  list:[]
                },
                checkBox:'',
                selectName:'',
                radioName:'',
                selectList:[],
                radioList:[],
                checkBoxList:[],
                viewRange:'',
                selectId:0,
                radioId:0,
                checkBoxId:0,
                datePickerId:0,
                timePickerId:0,
                cascadeId:0,
                cascadeValue:[],
                datePickerList:[],
                timePickerList:[],
                fieldSelectList:[],
                fieldCheckBoxList:[],
                fieldRadioList:[],
                fieldCascadeList:[],
                customFieldFilterValue:[],
                orderFilterList:[],
                notShowOrderFilterList:[],
                filterId:0,
                showFilterList:[],
                props: { multiple: true},
                allOrderFilterList:[],
                orderFilterId:'',
                allOrderNum:0,
                selectAccountGroup:[],
                selectAccountPerson:[],
                selectPrincipal:[],
                selectFocusPerson:[],
                editSelectFocusPerson:[],
                editSelectPrincipal:[],
              templateSelect:[],
              workOrderTemplate:{
                list:[]
              },
                createDateRange:[],
                updateTimeRange:[]

            }
        },
        props:{
            orderList:{
                type:Array,
                default(){
                    return []
                }
            },
          dynamicTags:{
              type:Number
          }
        },
        mounted() {
            window.onresize=()=>{
                return (() => {
                    this.setDialogWidth()
                })
            }


        },
      beforeMount() {
        if(this.getVal('id')!==false&&localStorage.getItem('dynamicTags')===null)
        {
          this.currentIndex=this.getVal('id')
        }

      },
      filters:{
        },
        methods:{
          getVal(key){
            var url = location.href.split("?");
            if(url[1]==null)return false;
            var field = url[1].split("&");
            for(let i=0;i<field.length;i++){
              var val = field[i].split("=");
              if(val[0]==key){
                return val[1];
              }
            }
            return false;
          },

            noClick(){


            },
            customFilter(){
                this.filterName=''
                this.timePicker=[]
                this.datePicker=[]
                this.groupInput=''
                this.editGroupInput=''
                this.personInput=''
                this.createPersonInput=''
                this.focusPersonInput=''
                this.createDateRange=[]
                this.updateTimeRange=[]
                for (let i=0;i<this.fieldCheckBoxList.length;i++)
                {
                    this.checkBoxCheck[i]=[]
                }
                for (let i=0;i<this.fieldRadioList.length;i++)
                {
                    this.radioCheck[i]=[]
                }

                this.acceptanceGroup=[]
                this.createPerson=[]
                this.focusPerson=[]
                this.acceptancePerson=[]
                this.priorityList=[]
                 this.selectValue=[]
                 this.statusList=[]
              this.templateSelect=[]
                this.dialogFormVisible = true
            },
            //点击编辑过滤器
            itemClick(index,filterId){
                    this.groupInput=''
                    this.editGroupInput=''
                    this.personInput=''
                    this.createPersonInput=''
                    this.focusPersonInput=''
                    this.selectValue=[]
                    this.timePicker=[]
                    this.timePicker=[]
                    this.datePicker=[]
                    this.cascadeValue=[]
                    this.acceptanceGroup=[]
                    this.focusPerson=[]
                    this.createPerson=[]
                    this.acceptancePerson=[]
                     this.priorityList=[]
                   this.templateSelect=[]
                this.updateTimeRange=[]
                this.createDateRange=[]
                    this.filterId=filterId
                   console.log(this.orderFilterList[index])
                    this.statusList=this.orderFilterList[index].content.statusId

                    this.filterName=this.orderFilterList[index].name
                    if(this.orderFilterList[index].scope==='UID')
                        this.rangeRadio='1'
                    if(this.orderFilterList[index].scope==='MID')
                        this.rangeRadio='2'
                    this.acceptanceGroup=this.orderFilterList[index].content.assigneeGroupIds
                    this.createPerson=this.orderFilterList[index].content.creatorIds
                    this.focusPerson=this.orderFilterList[index].content.followersIds
                    this.acceptancePerson=this.orderFilterList[index].content.assigneeIds
                    this.priorityList=this.orderFilterList[index].content.priorities
                   this.templateSelect=this.orderFilterList[index].content.templateIds
                    if(this.orderFilterList[index].content.updateTimeRange!==null)
                    {
                        this.updateTimeRange=this.orderFilterList[index].content.updateTimeRange
                    }
                    if(this.orderFilterList[index].content.createDateRange!==null)
                    {
                        this.createDateRange=this.orderFilterList[index].content.createDateRange
                    }
                    for(let i=0;i<this.fieldSelectList.length;i++)
                    {
                        if( this.fieldSelectList[i].id in this.orderFilterList[index].content.customFieldFilterValue)
                            this.selectValue[i]=this.orderFilterList[index].content.customFieldFilterValue[this.fieldSelectList[i].id]
                    }
                    for(let i=0;i<this.fieldCheckBoxList.length;i++)
                    {
                        if( this.fieldCheckBoxList[i].id in this.orderFilterList[index].content.customFieldFilterValue)
                            this.checkBoxCheck[i]=this.orderFilterList[index].content.customFieldFilterValue[this.fieldCheckBoxList[i].id]
                    }
                    for(let i=0;i<this.fieldRadioList.length;i++)
                    {
                        if( this.fieldRadioList[i].id in this.orderFilterList[index].content.customFieldFilterValue)
                            this.radioCheck[i]=this.orderFilterList[index].content.customFieldFilterValue[this.fieldRadioList[i].id]
                    }

                    for(let i=0;i<this.timePickerList.length;i++)
                    {
                        if( this.timePickerList[i].id in this.orderFilterList[index].content.customFieldFilterValue)
                            this.timePicker[i]=this.orderFilterList[index].content.customFieldFilterValue[this.timePickerList[i].id]
                    }

                    for(let i=0;i<this.datePickerList.length;i++)
                    {
                        if( this.datePickerList[i].id in this.orderFilterList[index].content.customFieldFilterValue)
                            this.datePicker[i]=this.orderFilterList[index].content.customFieldFilterValue[this.datePickerList[i].id]
                    }

                    for(let i=0;i<this.fieldCascadeList.length;i++)
                    {
                        if( this.fieldCascadeList[i].id in this.orderFilterList[index].content.customFieldFilterValue)
                            this.cascadeValue[i]=this.orderFilterList[index].content.customFieldFilterValue[this.fieldCascadeList[i].id]
                    }

                    this.dialogFormVisible1 = true
                    this.orderFilterId=filterId


            },
            setDialogWidth() {
                const val = document.body.clientWidth
                const def = 450 // 默认宽度
                if (val < def) {
                    this.dialogWidth = '100%'
                } else {
                    this.dialogWidth = def + 'px'
                }
            },
            mouseClick(index){
                this.moseover=index
            },
            mouseOutClick(){
                this.moseover=''
                this.mouseout=1
            },
            //获取所有的可显示和不可显示的过滤器
            getAllOrderFilter(){
                this.$http.get('/api/filter/list?type=ORDER').then(res=>{
                    this.allOrderFilterList=res.data.data

                })
            },


            //获取可显示工单管理的过滤器
            getOrderFilter(){
                this.orderFilterList=[]
                this.$http.get('/api/filter/list?display=true&type=ORDER').then(res=>{
                    this.orderFilterList=res.data.data

                    this.currentIndex=this.orderFilterList[0].id

                    this.showFilterList= this.orderFilterList
                })
            },
            ConfigurationFilter(){
                this.getAllOrderFilter()
                this.dialogFormVisible2=true
            },
            //获取不可显示的工单过滤器
          /*  getNotShowOrderFilter(){
                this.$http.get('/api/filter/list?display=false&type=ORDER').then(res=>{
                    this.notShowOrderFilterList=res.data.data
                })
            },
*/
            //增加工单管理的过滤器
            addWorkOrderFilter(){
                if(this.rangeRadio==='1')
                    this.viewRange='UID'
                if(this.rangeRadio==='2')
                    this.viewRange='MID'
                let customFieldFilterValue={}
                    for(let i=0;i<this.fieldSelectList.length;i++)
                    {
                      console.log(this.selectValue)
                        if(this.selectValue[i].length !==0)
                            customFieldFilterValue[this.fieldSelectList[i].id]=this.selectValue[i]
                    }
                    for(let i=0;i<(this.fieldCheckBoxList).length;i++)
                    {
                      console.log(this.checkBoxCheck)
                        if(this.checkBoxCheck[[i]].length !==0)
                            customFieldFilterValue[this.fieldCheckBoxList[i].id]=this.checkBoxCheck[i]
                    }

                    for(let i=0;i<this.fieldRadioList.length;i++)
                    {
                      console.log(this.radioCheck)
                        if((this.radioCheck[[i]]).length !==0)
                            customFieldFilterValue[this.fieldRadioList[i].id]=this.radioCheck[i]
                    }
                    for(let i=0;i<this.timePickerList.length;i++)
                    {
                      console.log(this.timePicker)
                        if(this.timePicker[i]!==undefined)
                            customFieldFilterValue[this.timePickerList[i].id]=this.timePicker[i]
                    }

                    for(let i=0;i<this.datePickerList.length;i++)
                    {
                        if(this.datePicker[i]!==undefined)
                            customFieldFilterValue[this.datePickerList[i].id]=this.datePicker[i]
                    }

                    for(let i=0;i<this.fieldCascadeList.length;i++)
                    {
                      console.log(this.cascadeValue)
                        if(this.cascadeValue[i]!==undefined)
                            customFieldFilterValue[this.fieldCascadeList[i].id]=this.cascadeValue[i]
                    }

                    console.log(customFieldFilterValue)
              let acceptanceGroup=[]
              let acceptancePerson=[]
              let focusPerson=[]
              let createPerson=[]
              for (let i=0;i<this.acceptanceGroup.length;i++)
              {
                if(this.acceptanceGroup[i]!==null)
                  acceptanceGroup.push(this.acceptanceGroup[i])
              }
              for (let i=0;i<this.acceptancePerson.length;i++)
              {
                if(this.acceptancePerson[i]!==null)
                  acceptancePerson.push(this.acceptancePerson[i])
              }
              for (let i=0;i<this.createPerson.length;i++)
              {
                if(this.createPerson[i]!==null)
                  createPerson.push(this.createPerson[i])
              }
              for (let i=0;i<this.focusPerson.length;i++)
              {
                if(this.focusPerson[i]!==null)
                  focusPerson.push(this.focusPerson[i])
              }
              this.acceptanceGroup=acceptanceGroup
              this.acceptancePerson=acceptancePerson
              this.createPerson=createPerson
              this.focusPerson=focusPerson

                if(this.filterName!=='')
                {
                    this.$http.post('/api/filter/order',{
                        assigneeGroupIds: this.acceptanceGroup,
                        assigneeIds: this.acceptancePerson,
                        customFieldFilterValue:customFieldFilterValue,
                        filterBaseInfo: {
                            "name": this.filterName,
                            "scope": this.viewRange,
                            "type": "ORDER"
                        },
                        priorities: this.priorityList,
                        statusId:this.statusList,
                        creatorIds:this.createPerson,
                        followersIds:this.focusPerson,
                        templateIds:this.templateSelect,
                        updateTimeRange:this.updateTimeRange,
                        createDateRange:this.createDateRange
                    }).then(res=>{
                        if(res.data.code==='0'){
                            this.$message.success('添加过滤器成功')
                            this.getOrderFilter()
                        }
                        else
                            this.$message('添加失败')

                    })
                    this.dialogFormVisible=false
                }
                else
                    this.$message.error('请填写过滤器的名称')
            },

            //编辑过滤器
            ModifyWorkOrderFilter(){
                if(this.rangeRadio==='1')
                    this.viewRange='UID'
                if(this.rangeRadio==='2')
                    this.viewRange='MID'
                let customFieldFilterValue={}

              for(let i=0;i<this.fieldSelectList.length;i++)
              {
                if(this.selectValue.length > 0)
                {
                  if(this.selectValue[i].length !==0)
                    customFieldFilterValue[this.fieldSelectList[i].id]=this.selectValue[i]
                }

              }
              for(let i=0;i<(this.fieldCheckBoxList).length;i++)
              {
                if(this.checkBoxCheck.length > 0)
                {
                  if(this.checkBoxCheck[[i]].length !==0)
                    customFieldFilterValue[this.fieldCheckBoxList[i].id]=this.checkBoxCheck[i]
                }
              }

              for(let i=0;i<this.fieldRadioList.length;i++)
              {
                console.log(this.radioCheck.length)
                if(this.radioCheck.length > 0)
                {
                  if((this.radioCheck[[i]]).length !==0)
                    customFieldFilterValue[this.fieldRadioList[i].id]=this.radioCheck[i]
                }
              }
                for(let i=0;i<this.timePickerList.length;i++)
                {
                    if(this.timePicker[i]!==undefined)
                        customFieldFilterValue[this.timePickerList[i].id]=this.timePicker[i]
                }
                for(let i=0;i<this.datePickerList.length;i++)
                {
                    if(this.datePicker[i]!==undefined)
                        customFieldFilterValue[this.datePickerList[i].id]=this.datePicker[i]
                }
                for(let i=0;i<this.fieldCascadeList.length;i++)
                {
                    if(this.cascadeValue[i]!==undefined)
                        customFieldFilterValue[this.fieldCascadeList[i].id]=this.cascadeValue[i]
                }
                let acceptanceGroup=[]
              let acceptancePerson=[]
              let focusPerson=[]
              let createPerson=[]
              for (let i=0;i<this.acceptanceGroup.length;i++)
              {
                if(this.acceptanceGroup[i]!==null)
                  acceptanceGroup.push(this.acceptanceGroup[i])
              }
              for (let i=0;i<this.acceptancePerson.length;i++)
              {
                if(this.acceptancePerson[i]!==null)
                  acceptancePerson.push(this.acceptancePerson[i])
              }
              for (let i=0;i<this.createPerson.length;i++)
              {
                if(this.createPerson[i]!==null)
                  createPerson.push(this.createPerson[i])
              }
              for (let i=0;i<this.focusPerson.length;i++)
              {
                if(this.focusPerson[i]!==null)
                  focusPerson.push(this.focusPerson[i])
              }
              this.acceptanceGroup=acceptanceGroup
              this.acceptancePerson=acceptancePerson
              this.createPerson=createPerson
              this.focusPerson=focusPerson
                let info={
                    assigneeGroupIds: this.acceptanceGroup,
                    assigneeIds: this.acceptancePerson,
                    customFieldFilterValue:customFieldFilterValue,
                    filterBaseInfo: {
                        "name": this.filterName,
                        "scope": this.viewRange,
                        "type": "ORDER"
                    },
                    priorities: this.priorityList,
                    statusId:this.statusList,
                    creatorIds:this.createPerson,
                    followersIds:this.focusPerson,
                    templateIds:this.templateSelect,
                    updateTimeRange:this.updateTimeRange,
                    createDateRange:this.createDateRange
                }
                if(this.filterName!=='')
                {
                    this.$http.put('/api/filter/order/'+this.filterId,{
                        assigneeGroupIds: this.acceptanceGroup,
                        assigneeIds: this.acceptancePerson,
                        customFieldFilterValue:customFieldFilterValue,
                        filterBaseInfo: {
                            "name": this.filterName,
                            "scope": this.viewRange,
                            "type": "ORDER"
                        },
                        priorities: this.priorityList,
                        statusId:this.statusList,
                        creatorIds:this.createPerson,
                        followersIds:this.focusPerson,
                        templateIds:this.templateSelect,
                        updateTimeRange:this.updateTimeRange,
                        createDateRange:this.createDateRange
                    }).then(res=>{
                        if(res.data.code==='0'){
                            this.$message.success('修改过滤器成功')
                            this.getOrderFilter()
                            this.$emit('ModifyWorkOrderFilter',info)
                        }
                        else
                            this.$message('修改失败')

                    })
                    this.dialogFormVisible1=false
                }
                else
                    this.$message('请填写过滤器的名称')
            },
            //获取自定义的字段
            getFieldList() {
                this.$http.get('/api/field/list?searchable=true').then(response => {
                        this.fields.list = response.data.data;

                        this.fields.list.find(item=>{
                            if(item.type==='DATE_PICKER')
                                this.datePickerList.push(item)
                            if(item.type==='TIME_PICKER')
                                this.timePickerList.push(item)
                            if(item.type==='SELECT')
                                this.fieldSelectList.push(item)
                            if(item.type==='CHECKBOX')
                                this.fieldCheckBoxList.push(item)
                            if(item.type==='RADIO')
                                this.fieldRadioList.push(item)
                            if(item.type==='CASCADER')
                                this.fieldCascadeList.push(item)
                        })
                        for (let i =0;i<this.fieldCheckBoxList.length;i++)
                            this.checkBoxCheck.push([])
                        for (let i =0;i<this.fieldRadioList.length;i++)
                            this.radioCheck.push([])
                        for(let i=0;i<this.fieldSelectList.length;i++)
                            this.selectValue.push([])
                        console.debug('FieldApiExample field page:', this.fields);
                    })
            },

            //删除数组中存在的重复字段
            unique() {
                const res = new Map();
                return this.status.list.filter((item) => !res.has(item.id) && res.set(item.id, 1));
            },
            //获取状态值
            getStatusList(){
                this.$http.get('/api/status/list')
                    .then(response => {
                        this.status.list = response.data.data;
                        this.newStatus.list=this.unique()
                        console.debug('FieldApiExample field page:', this.status);
                    })
            },

            //获取受理组
            getAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.accountGroup.list=res.data.data
                    this.selectAccountGroup=res.data.data
                })
            },


            //获取受理人,创建人，关注人的下拉列表
            getPrincipals(){
                    this.$http.get('/api/account/principals?groupIds=%20').then(res=>{
                        this.Principals.list=res.data.data
                        this.selectPrincipal=res.data.data
                        this.selectFocusPerson=res.data.data
                        this.editSelectFocusPerson=res.data.data
                        this.editSelectPrincipal=res.data.data
                        this.accountPerson.list=res.data.data
                        this.selectAccountPerson=res.data.data
                    })
            },

          //获取工单模板
          getTemplate(){
            this.$http.get('/api/template/list').then(res=>{
              this.workOrderTemplate.list=res.data.data
              console.log(this.workOrderTemplate.list)
            })
          },
            filterToRight(filterid){
                this.allOrderFilterList.forEach(item=>{
                    if(item.id===filterid)
                        item.display=true
                })
             /*   this.showFilterList.push(this.notShowOrderFilterList[index])
                this.notShowOrderFilterList.splice(index,1)
                console.log(this.orderFilterList)
                console.log(filterid)*/
            },
            filterToLeft(filterid){
                this.allOrderFilterList.forEach(item=>{
                    if(item.id===filterid)
                        item.display=false
                })

            },

            //调整配置过滤器中显示过滤器的顺序
            resortFilter(){
                let _this = this;
                let el = document.getElementById('workOrderFilter');
                new Sortable(el,{
                    animation: 200,
                    handle: '.handle',
                    ghostClass: 'blue-background-class',
                    easing: "cubic-bezier(1, 0, 0, 1)",
                    onUpdate:function(event){
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el.children[newIndex],
                            $oldLi = el.children[oldIndex];
                        // 先删除移动的节点
                        el.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if(newIndex > oldIndex) {
                            el.insertBefore($li,$oldLi)
                        } else {
                            el.insertBefore($li,$oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.allOrderFilterList.splice(oldIndex,1)
                        _this.allOrderFilterList.splice(newIndex,0,item[0])
                        // 下一个tick就会走patch更新

                    },

                });
               /* let orderList=[]
                _this.allOrderFilterList.forEach(item=>{
                    if(item.display===true)
                        orderList.push(item)
                })
                this.orderFilterList=orderList*/
                this.allOrderFilterList=_this.allOrderFilterList
            },
            changeFilter(){
                let el2= document.getElementById('workOrderNotShowFilter')
                new Sortable(el2,{
                    animation: 150,
                    easing: "cubic-bezier(1, 0, 0, 1)",
                })
            },
            filterClick(index,filterId){
            /*  let orderFilterList*/
              let filterInfo
              this.$http.get('/api/filter/list?display=true&type=ORDER').then(res=>{
                filterInfo=res.data.data
                for (let i=0;i<filterInfo.length;i++)
                {
                  if(filterInfo[i].id === filterId)
                  {
                    this.$emit('filterClick',filterInfo[i].content)
                  }
                }

              })
              this.currentIndex=filterId
              this.$router.push({
                path:'/workorderinfo',
                query:{
                  id:filterId
                }
              })


            },
            workOrderFilterDisplay(){
                let showFilter=[]
                let hideFilter=[]
                for (let i=0;i<this.allOrderFilterList.length;i++)
                {
                    if(this.allOrderFilterList[i].display===true)
                        showFilter.push(this.allOrderFilterList[i].id)
                    if(this.allOrderFilterList[i].display===false)
                        hideFilter.push(this.allOrderFilterList[i].id)
                }
                this.$http.post('/api/filter/config',{
                    hideList:hideFilter,
                    showList:showFilter
                }).then(res=>{
                    if(res.data.code==='0')
                    {
                        this.$message.success('过滤器配置成功')
                        this.getOrderFilter()
                    }

                })
                this.dialogFormVisible2 = false
            },
            deleteOrderFilter(){
                this.$http.delete('/api/filter/'+this.orderFilterId).then(res=>{
                    if(res.data.code==='0')
                        this.$message.success('删除过滤器成功')
                    this.getOrderFilter()
                })
                this.dialogVisible=false
                this.dialogFormVisible1 = false
            },
            IsDeleteOrdeFilter(){
                this.dialogVisible=true
            },
            changeSelectGroup(value){
                if(value!=='')
                {
                    let selectCompany=[]
                    this. accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompany.push(item)
                        }
                    })
                    this.selectAccountGroup=selectCompany
                }
                else
                {
                    this.selectAccountGroup=this.accountGroup.list
                }

            },
            changeSelectPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this. accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectAccountPerson=selectPerson

                }
                else
                {
                    this.selectAccountPerson=this.accountPerson.list
                }

            },
            changeSelectCreatePerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this. Principals.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectPrincipal=selectPerson

                }
                else
                {
                    this.selectPrincipal=this.Principals.list
                }


            },
            selectEditFilterPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this. Principals.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.editSelectPrincipal=selectPerson

                }
                else
                {
                    this.editSelectPrincipal=this.Principals.list
                }

            },
            changeSelectCreatePerson2(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this.Principals.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.selectFocusPerson=selectPerson

                }
                else
                {
                    this.selectFocusPerson=this.Principals.list
                }


            },
            selectEditFilterFocusPerson(value){
                if(value!=='')
                {
                    let selectPerson=[]
                    this. Principals.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectPerson.push(item)
                        }
                    })
                    this.editSelectFocusPerson=selectPerson

                }
                else
                {
                    this.editSelectFocusPerson=this.Principals.list
                }
            },
            myUnsolvedOrder(){
                this.currentIndex='myUnsolvedOrder'
            },
            groupUnsolvedOrder(){
                this.currentIndex='groupUnsolvedOrder'
            },
            allUnsolvedOrder(){
                this.currentIndex='allUnsolvedOrder'
            },
            mySolvedOrder(){
                this.currentIndex='mySolvedOrder'
            }

        },
        watch:{
          dynamicTags:{
            handler(a){
              if(a === 0)
              {
                 this.currentIndex=this.orderFilterList[0].id
              }
            },
            deep:true,
          },
         /* $route: {
            handler() {
              this.filterId = this.$route.query.id;
              this.getWorkOrderList();
              //深度监听，同时也可监听到param参数变化
            },
            deep: true,
          }*/

            /*getAllOrder:function (a) {
                this.allOrderNum=a.data.data.totalElements
            },
            orderList(a){
                this.allOrderNum=a.length
            }*/
        }
    }
</script>

<style lang="less">
@import "../../../assets/less/workorder/sidebar/sidebar";
.blue-background-class{
    background-color: #F1F4F5;
}
.checkAllOrder{
    color: #409EFF;
}
.el-checkbox{
    margin-right: 0;
}
</style>